<script setup>
import {computed, onMounted, ref} from "vue";
import store from "@/store";
import {payType} from "@/utils/config";
import {Swiper, SwiperSlide} from "swiper/vue";

// 如果需要自定义Swiper的选项，可以导入Swiper类并创建实例
import {EffectCards, Navigation} from 'swiper/modules';
import SwiperCore from "swiper"
import "swiper/css"
import 'swiper/css/navigation'
import {useRoute} from "vue-router";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";
import {dateFormat} from "@/utils/func";

SwiperCore.use([EffectCards, Navigation]);

const type = computed(() => {
  let pay = store.state.pay_type
  console.log(pay)
  if (!pay) return {}
  pay = payType[pay]
  // document.title = pay.title
  return pay
})
const account = computed(() => store.state.account)
const order = ref({})
const route = useRoute()
onMounted(() => {
  document.title = "权益券码";
  store.commit("getAccount")
  if (route.query.ordersn) {
    new axiosApi({
      method: "coupon/orderDetails",
      encode: "site",
      body: {ordersn: route.query.ordersn},
    }).send(res => {
      if (res.message.code === "000") {
        order.value = res.data
        store.commit('setPayType', res.data.pay_type === '9' ? 'xm_air' : 'scal')
      } else {
        router.push({name: "home"})
      }
    })
  }
});
const term = computed(() => {
  // return (dateFormat(order.value.hasCoupon[0].term * 1000)) ||""
  return order.value.hasCoupon.length ? dateFormat(order.value.hasCoupon[0].term * 1000) : ""
})
const couponNumber = computed(() => {
  if (order.value.hasCoupon.length < 1) return 0
  let coupons = order.value.hasCoupon.filter(its => its.is_use === 1 && Math.floor((new Date().getTime()) / 1000) < its.term)
  return coupons.length
})

const couponDet = () => {
  window.location.replace(`https://pay.jifen360.com/third/scal-app/morestore.html?type=coupon&cid=${order.value.coupon_id}`)

}
</script>

<template>
  <el-scrollbar class="page-pid order-details" :style="type?.view"
                v-if="Object.keys(order).length && Object.keys(type).length">
    <div class="order-details-header">
      <div class="order-details-header-info">
        <div class="icon-pay">
          <el-image :src="type?.success"/>
        </div>
        <div style="line-height: 1.75">
          <h3>兑换成功！</h3>
          <div>感谢您的兑换</div>
        </div>
      </div>
      <div class="border-icon"></div>
    </div>
    <div class="order-info">
      <div class="order-info-title">
        <h3>机场高铁消费券</h3>
        <div class="order-price">
          <sup>￥</sup><span class="order-face-value">{{ parseFloat(order?.couponItems?.face_value) }}</span>
        </div>
        <div>有效期：{{ term }}</div>
        <div>共{{ order?.buy_count }}张，可用{{ couponNumber }}张，合计{{ parseFloat(order?.total_price) }}元</div>
      </div>
      <swiper loop class="order-qrcode" navigation
              :scrollbar="{ draggable: true }" v-if="order.order_status === 1">
        <swiper-slide v-for="(inx) in order.hasCoupon" :key="inx">
          <div class="order-info-qrcode-empty" v-if="inx.draw_status !== 2">
            订单处理中
          </div>
          <div v-else-if="inx.is_use === 1">
            <div class="barcode">
              <el-image :src="`https://cloud.jifen360.com/barcode/${inx.code}`"/>
            </div>
            <div class="qrcode">
              <el-image :src="`https://open.jifen360.com/qrcode/${inx.code}`"/>
            </div>
          </div>
          <div class="order-info-qrcode-empty" v-else>
            已使用
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="options">
      <el-button type="primary" color="var(--btn-color)" style="margin-bottom: 10px" round @click="couponDet">
        查看适用门店列表
      </el-button>
      <!--  https://pay.jifen360.com/third/scal-app/morestore.html?type=coupon&cid=  -->
      <el-button type="primary" color="var(--btn-color)" style="margin-bottom: 10px" round
                 @click="router.replace({name:'order'})" v-if="Object.keys(account).length">查看订单
      </el-button>
      <el-button type="primary" color="var(--btn-color)" style="margin-bottom: 10px" round
                 @click="router.replace({name:'home'})">再来一单
      </el-button>
    </div>

  </el-scrollbar>
</template>

<style scoped lang="less">
.order-details {
  height: 100vh;

  .order-details-header {
    height: 240px;
    background: var(--btn-color);
    color: #ffffff;

    .order-details-header-info {
      display: flex;
      justify-content: center;
      padding: 30px 0;
      align-items: center;

      .icon-pay {
        width: 65px;
        height: 65px;
        margin-right: 20px;
      }
    }

    .border-icon {
      //width: 100%;
      height: 10px;
      background-color: var(--success-border-color);
      border-radius: 10px;
      margin: 0 20px;
    }
  }

  .order-info {
    box-sizing: border-box;
    //padding: 20px;
    background: #ffffff;
    box-shadow: var(--el-box-shadow);
    margin: -109px 32px 15px;

    .order-info-title {
      text-align: center;
      line-height: 1.75;
      padding: 20px;
      border-bottom: 1px dashed var(--el-border-color);
      font-weight: 600;
    }

    .order-price {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      font-weight: 600;
      margin: 15px auto;

      .order-face-value {
        display: inline-block;
        margin-top: -10px;
        font-size: 1.75rem;
      }
    }
  }

  .order-qrcode {
    //padding: 30px;
    margin-top: 30px;
    padding-bottom: 30px;
    text-align: center;

    .barcode {
      .el-image {
        height: 45px;
        width: 220px;
      }
    }

    .qrcode {
      width: 100px;
      margin: auto;

      .el-image {
        height: 100px;
        width: 100px;
      }
    }
  }

  .options {
    margin: 30px;

    .el-button {
      width: 100%;
      margin-right: 0 !important;
      margin-left: 0;
      display: block;
      //line-height: 45px;
      height: 45px;
    }
  }
}

.order-info-qrcode-empty{
  width: 120px;
  height: 120px;
  line-height: 120px;
  margin: auto;
  background-color: #f5f7fa;
}
</style>
